<!-- 缺货-标记商品缺货 -->
<template>
  <div class="order_detail">
    <div class="order_head">
      <div class="order_head_title flex">
        <div class="page_title" style="width: 1%;margin-right: 30px;">
          <custom-breadcrumb :suffix="`Order NO. ${orderId}`"/>
        </div>
        <div class="page_button" >

        </div>
      </div>
      <div class="order_nav flex">
        <div class="nav_msg flex">
          <p class="nac_msg_name">Order total</p>
          <p class="nac_msg_num">{{ tsStoreOrderInfo['payAmount'] }}</p>
        </div>
        <div class="nav_msg flex">
          <p class="nac_msg_name">Orders Date</p>
          <p class="nac_msg_num">{{ orderDate }}</p>
        </div>
        <div class="nav_msg flex">
          <p class="nac_msg_name">Orders Status</p>
          <p class="nac_msg_num">{{ orderStatus }}</p>
        </div>
        <div class="nav_msg flex address_width">
          <p class="nac_msg_name">
            Ship To
            <template v-if="!finalStatus.includes(tsStoreOrderInfo['orderStatus'])">
              <span @click="openAddress"><img src="@/assets/img/memo.png" alt=""></span>
            </template>
          </p>
          <!-- vidirect用户显示地址，，或者非vidirect用户下的备货中显示地址 -->
          <p class="nac_msg_num" style="padding-top: 0px"
             v-if="isVidirect || (tsStoreOrderInfo['orderStatus']!==0 && tsStoreOrderInfo['orderStatus']!==1 && tsStoreOrderInfo['orderStatus']!==2 && tsStoreOrderInfo['orderStatus']!==10 && tsStoreOrderInfo['orderStatus']!==11)">
            <!-- vidirect用户一定显示， 或者brandShippingModel=1平台发货(CN)  2自发货 -->
            <template v-if="isVidirect || brandShippingModel==='2'">
              {{ tsStoreOrderAddress.name }}&nbsp;&nbsp;{{ tsStoreOrderAddress.lastname }}
              <br>
              {{ tsStoreOrderAddress.address }}&nbsp;
              <br>
              {{ tsStoreOrderAddress.city }}, {{ tsStoreOrderAddress.province }}, {{ tsStoreOrderAddress.countryName }}&nbsp;&nbsp;{{
                tsStoreOrderAddress.postCode
              }}
              <br>
              {{ tsStoreOrderAddress.areaCode }}-{{ tsStoreOrderAddress.phone }}
            </template>
            <template v-else>
              ShopVidi（收）
              <br>
              深圳市宝安区福海街道新和社区红牌工业园华丰智谷福海科技产业园A栋 A326-1
              <br>
              18038059068
            </template>

          </p>
          <p v-else>-</p>

        </div>
        <div class="nav_msg flex" style="width:20%">
          <p class="nac_msg_name no_border">Customer</p>
          <p class="nac_msg_num no_border">{{ customer }}</p>
        </div>
      </div>

    </div>
    <div class="order_main">

      <el-table :data="skuList"  style="width: 100%">
        <el-table-column prop="date" label="Item" width="420">
          <template slot-scope="scope">
            <div class="prduct_box">
              <img class="product_img" :src="scope.row.skuImg" alt=""/>
              <div class="product_info">
                <p class="product_name">
                  {{ scope.row.skuName }}
                </p>
                <p class="product_size">
                  {{ scope.row['finalSkuName'] }}
                  <span style="color: #8F8F8F;margin-left: 15px;font-size: 14px;"> {{ scope.row['skuCode'] }}</span>
                </p>
                <div class="product_tips" v-if="scope.row.orderStatus === 3">The item is shipped</div>
                <div class="product_tips" v-if="scope.row.orderStatus === 7">The item is refunded</div>
                <div class="product_tips" v-if="scope.row.orderStatus === 16">The item is refunding</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="FOB Price" width="150">
          <template slot-scope="scope">
            <div class="prduct_box flex">
              <span >{{ scope.row['fobPriceFinal'] | fixed2 }}</span>

            </div>
          </template>
        </el-table-column>
        <el-table-column label="Wholesale Price" width="150">
          <template slot-scope="scope">
            <div class="prduct_box flex">
              {{ scope.row.unitPrice | fixed2 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Qty" width="100">
          <template slot-scope="scope">
            <div class="prduct_box flex qty-left">
              <span>{{ Number(scope.row['num']) }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Out of Stock Qty" width="150">
          <template slot-scope="scope">
            <div class="prduct_box flex qty-left">
              <span>{{ Number(scope.row['stockNum']) }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Pending Shipment QTY" width="180" style="position: relative;">
          <template slot-scope="scope">
            <div class="flex qty-left">
                  <el-input
                          class="price_input"
                          oninput="if(value){value=value.replace(/[^\d]/g,'')} "
                          v-model="scope.row['pendingShipmentQTY']"
                          @change="(e)=>changeNum(e,scope.$index,scope['row'])"
                          :disabled="(tsStoreOrderInfo['orderStatus']!==4 && scope.row['serviceOrderStatus']==2) || scope.row.orderStatus === 3 || scope.row.orderStatus === 7 || scope.row.orderStatus === 16"
                          placeholder="Pending Shipment QTY"
                        />
                 <div class="required-error" style="top:85px;" v-show="!scope['row']['serviceOrderWaitNum'] && scope['row']['serviceOrderWaitNum']!==0">Can't be blank</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Shipped Qty" width="100">
          <template slot-scope="scope">
            <div class="prduct_box flex qty-left">
              <span>{{ Number(scope.row['thirdDeliveredNum']) }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Total">
          <template slot-scope="scope">
            <div class="flex total_amount">
              <span>${{ (Number( !scope.row['isSkuChangePrice']?scope.row['unitPrice']:scope.row['unitPriceBeforeDiscount']) * Number(scope.row['num'])) | fixed2 }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 订单状态为未付款、付款失败不显示状态 -->
        <el-table-column label="Item Status" v-if="orderStatus !== 'Unpaid' && orderStatus !== 'Failed'" width="180">
          <template slot-scope="scope">
<!--            <span v-if="!scope.row['serviceOrderStatus'] || scope.row['serviceOrderStatus']==1">{{ scope.row.orderStatus | skuStatusFilter }}</span>
            <span style="color:#FF4812;text-decoration: underline;cursor: pointer" v-else
                  @click="gotoServiceOrders(scope.row.uid)">
                    {{ scope.row['serviceOrderStatus'] == 2 ? 'In-Service' : 'Refunded' }}
            </span>-->
            <!-- 上架或下架状态 -->
            <div class="table-cell-input" v-if="scope['row']['showStatusSelect']">
              <el-select placeholder="Please Select" :disabled="(tsStoreOrderInfo['orderStatus']!==4 && scope.row['serviceOrderStatus']==2) || scope.row.orderStatus === 3 || scope.row.orderStatus === 7 || scope.row.orderStatus === 16 "
                         v-model="scope.row['skuStatus']" @change="e=>changeSkuStatus(e,scope.row,scope.$index)">
                <el-option
                  v-for="item in skuStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.value==1 && scope['row']['stockNum']>0"
                >
                </el-option>

              </el-select>

            </div>

            <!-- 已经设置过补货时间 -->
            <div class="table-cell-input" v-else>
              <div style="font-size: 12px;color: #FB541C;">Restock by {{ scope['row']['restockDate'] }}</div>
              <div class="cust-sku-btn" style="text-align: left;">
                <span @click="resetRestock(scope['row'],scope.$index)">Restock</span>
                <span @click="showSetDate(scope['row'],scope.$index)">Change Date</span>
              </div>
            </div>

            <!-- 库存补货时间 -->
            <div class="set-restock-date" v-show="scope['row']['tmpStatus']=='99' ">
              <p>Set restock date</p>
              <el-date-picker
                v-model="restockDateArr[scope.$index]"
                style="margin-top: 10px;"
                type="date"
                :disabled="(tsStoreOrderInfo['orderStatus']!==4 && scope.row['serviceOrderStatus']==2) || scope.row.orderStatus === 3 || scope.row.orderStatus === 7 || scope.row.orderStatus === 16 || scope.row['serviceOrderStatus']==3"
                value-format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                format="MM/dd/yyyy"
                @change="(e)=>changeRestockDate(e,scope['row'],scope.$index)"
              >
              </el-date-picker>
              <div class="required-error" v-show="!restockDateArr[scope.$index]">Please set restock date</div>
              <div class="cust-sku-btn">
                 <span @click="submitRestockDate(scope['row'],scope.$index,false)">Cancel</span>
                 <span @click="submitRestockDate(scope['row'],scope.$index,true)">Save</span>
              </div>

            </div>

          </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="order_footer">
      <!-- 2.0.5 新增是否同步SKU状态 -->
      <div class="sync-sku">
        <el-checkbox v-model="isSyncSku">Synchronize setting the SKU items in the order as inactive.</el-checkbox>
      </div>
      <div class="tips-txt">If the item in the order is temporarily out of stock, select “Out of Stock” and set a replenishment date.
        If the product cannot be restocked within a short time, please select Inactive to unshelf the product</div>
      <div class="btn add-btn" @click="showConfirm">Submit</div>

    </div>

    <Address ref="address" :addressMessage="addressMessage"/>

    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      v-loading="loading"
      width="30%"
    >
      <span class="back_icon" @click="visible=false"><i class="el-icon-arrow-left"></i>Back</span>
      <p class="success_text">It cannot be updated after operation, please operate with caution!</p>
      <div class="flex_all" >
        <el-button
          type="primary"
          class="back_button"
          @click="submit()">
          Confirm
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {getAction, putAction, postAction} from '@/api/manage.js'
import {formateDate} from '@/components/formateEnDate.js'
import Address from '@/pages/components/address.vue'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import OutStock from './out-stock-confirm-dialog'
import {orderStatusDis, serviceOrderStatusDis} from '../../utils/status'

export default {
  components: {OutStock, Address, CustomBreadcrumb},
  data() {
    return {
      changeOrderId: '',
      changeOrderNum: '',
      acceptVisible: false,
      rowOrderID: '',
      copyVisible: false,
      orderLink: '',
      nowretailerName: '',
      copyEdit: false,
      visible: false,
      loading: false,
      timer: '',
      seconds: 5,
      orderId: '',
      brandShippingModel: '',
      paymentMethod: '', // 支付方式
      userInfo: '', // 收货人信息和手机号
      address: '', // 上方的shipto
      orderStatus: '', // 订单状态
      orderDate: 'Jan,1,1970', // 订单时间
      customer: '', // customer信息
      skuList: [], // sku信息
      iconFlag: false, // 标识显示哪张图片,
      isVidirect: false, // 是否为vidirect用户
      tsStoreOrderInfo: {}, // tsStoreOrderInfo memo
      addressMessage: {}, // 地址信息
      tsStoreOrderAddress: {}, // 接口地址赋值
      // 订单终态2已取消 3已发货 4部分发货 5已收货 6退款审核中 7已退款 8拒绝退款 9部分退款 13退货中 42终止发货 44,45,56确认发货 52部分送达 53已送达 57超时未收货 99交易关闭
      finalStatus: [2, 3, 4, 5, 6, 7, 8, 9, 13, 42, 44, 45, 46, 52, 53, 57, 99],
      skuStatusOptions: [{
        value: 1,
        label: 'Active'
      }, {
        value: 2,
        label: 'Inactive'
      }, {
        value: 0,
        label: 'Out of stock'
      }],
      restockDateArr: [],
      isSyncSku: true
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    // 1平台发货(CN)  2自发货
    // this.brandShippingModel = this.$route.query.brandShippingModel
    this.isVidirect = this.$route.query.userSource === '1'

    this.loadOrderDetails()
  },
  filters: {
    skuStatusFilter(f) {
      return orderStatusDis(f)
    },
    serviceStatusFilter(f) {
      return serviceOrderStatusDis(f)
    },
    fixed2: (v) => {
      let num = parseFloat(v), digit = 2
      return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit)
    }
  },
  methods: {
    gotoServiceOrders(orderDetailId) {
      this.$router.push({path: 'service-order', query: {orderDetailId: orderDetailId}})
    },

    async changeSkuStatus(status, row, index) {
      // if (status !== '0') {
      /* let res = await putAction(`/v0.2/brand/sku/${row['id']}/${status}`)
        this.$message.info(res.message) */
      this.$set(this.skuList[index], 'skuStatus', status)
      // }
      // tmpStatus设置为99，变量为后续判断使用
      this.$set(this.skuList[index], 'tmpStatus', status == 0 ? '99' : '')
    },
    changeRestockDate(value, row, index) {
    },
    async submitRestockDate(row, index, isSave) {
      if (isSave) {
        if (!this.restockDateArr[index]) {
          return
        }
        this.$set(row, 'restockDate', this.restockDateArr[index])

        this.$set(this.skuList[index], 'skuStatus', 0)
        this.$set(this.skuList[index], 'showStatusSelect', false)
      }

      // 如果点击了取消，并且没有设置补货日期，则还原成数据库值
      if (!isSave && !row.restockDate) {
        this.$set(row, 'skuStatus', row['skuStatusDb'])
      }
      this.$set(this.skuList[index], 'tmpStatus', '')
    },
    async resetRestock(row, index) {
      this.$set(row, 'skuStatus', row['stockNum'] > 0 ? 2 : 1)
      this.$set(row, 'restockDate', '')
      this.restockDateArr[index] = ''

      // 显示下拉框
      this.$set(row, 'showStatusSelect', true)
    },
    async showSetDate(row, index) {
      this.$set(row, 'tmpStatus', '99')
    },

    openAddress() {
      this.addressMessage = {
        addressId: this.tsStoreOrderAddress.addressId,
        userId: this.tsStoreOrderAddress.createBy,
        type: 'ordeDetail'
      }
      this.$refs.address.dialogVisible = true
    },

    loadOrderDetails() {
      if (this.orderId === '') {
        this.$message.warning('No Order')
        return
      }
      getAction('/order/api/v0.2/brand/orders/' + this.orderId + '/details').then(response => {
        if (response.success) {
          if (response.result) {
            this.handleAddress(response.result.tsStoreOrderAddress)
            this.handleCustomer(response.result.customer)
            this.tsStoreOrderInfo = response.result.tsStoreOrderInfo
            this.tsStoreOrderAddress = response.result.tsStoreOrderAddress
            this.brandShippingModel = response.result.brandShippingModel + ''

            this.orderStatus = orderStatusDis(this.tsStoreOrderInfo.orderStatus)

            // 默认都显示下拉框
            this.skuList = []
            let skuList = response.result.skuItemsList
            if (skuList && skuList.length > 0) {
              let newSkuList = skuList.map((x, i) => {
                this.restockDateArr.push(x['restockDateMmddyyyy'])

                // 有货（即上架）、下架都显示下拉框
                x['showStatusSelect'] = (x['skuStatus'] !== 0)
                x['skuStatusDb'] = x['skuStatus']
                x['restockDateDb'] = x['restockDateMmddyyyy']
                x['stockNumDb'] = x['stockNum']
                x['serviceOrderWaitNum'] = (x['serviceOrderWaitNum'] == null) ? x['num'] : x['serviceOrderWaitNum']
                x['pendingShipmentQTY'] = x['serviceOrderWaitNum'] - x['thirdDeliveredNum']
                x['pendingShipmentQTYDB'] = x['pendingShipmentQTY']
                return x
              })
              console.log(newSkuList)
              this.skuList = newSkuList
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    handleCustomer(customer) {
      if (customer === null || JSON.stringify(customer) === '{}') {
        return
      }
      if (customer.userName) {
        this.customer = customer.userName + '(Level  ' + customer.level + ')'
      }
    },
    handleAddress(addressInfo) {
      if (JSON.stringify(addressInfo) === '{}') {
        return
      }
      this.userInfo = addressInfo.name + '  ' + addressInfo.lastname + '   ' + addressInfo.areaCode + '-' + addressInfo.phone
      this.address = '【' + addressInfo.countryName + '】' + addressInfo.province + ' , ' + addressInfo.city + ' , ' + addressInfo.postCode + ' , ' + addressInfo.address
    },

    changeNum(e, index, row) {
      if (e !== '') {
        let value = Number(e)
        if (value > row['pendingShipmentQTYDB']) {
          this.$set(row, 'pendingShipmentQTY', row['pendingShipmentQTYDB'])
        }

        // 修改out of stack
        this.$set(row, 'stockNum', row['num'] - row['pendingShipmentQTY'] - row['thirdDeliveredNum'])
        // 小于等于num-out of stack
        this.$set(row, 'serviceOrderWaitNum', Number(row['pendingShipmentQTY']) + Number(row['thirdDeliveredNum']))

        // OI有可缺货/下架OI数量>0时，对应SKU状态必须下架或缺货；Items Status的Active置灰不可选
        let flag = row['skuStatus'] !== 1
        this.$set(row, 'skuStatus', row['stockNum'] > 0 ? (flag ? row['skuStatus'] : 2) : 1)
      }
    },

    showConfirm() {
      let emptyLen = this.skuList.filter(f => f['serviceOrderWaitNum'] == '' && f['serviceOrderWaitNum'] !== 0).length
      if (emptyLen > 0) {
        return
      }
      this.visible = true
    },
    submit() {
      let emptyLen = this.skuList.filter(f => f['serviceOrderWaitNum'] == '' && f['serviceOrderWaitNum'] !== 0).length
      if (emptyLen > 0) {
        return
      }
      console.log(this.skuList)
      this.loading = true
      postAction(`order/api/v0.2/brand/orders/${this.orderId}/mark-out-stock?isSyncSku=${this.isSyncSku}`, this.skuList).then((res) => {
        this.loading = false
        this.visible = false
        if (res.success) {
          this.$message.success(res.message)
        } else {
          this.$message.warning(res.message)
        }
        this.$router.push(
          {
            path: 'OrderDetail',
            query: {'orderId': this.orderId, 'userSource': this.$route.query.userSource}
          }
        )
      })
    }

  }
}
</script>

<style lang="less" scoped>

.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  margin: 0 0 0 10px;
}

.border_box {
  width: 80%;
  height: auto;
  padding: 20px;
  border: 1px solid #dcdfe6;
  margin: 10px 0 15px 10%;

  .copy_title {
    font-size: 13px;
    font-family: Graphik;
    font-weight: 500;
    line-height: 28px;
    color: #262b2f;
  }

  .copy_subtitle {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 18px;
    color: #5d5d5d;
  }
}

.confirm_button {
  background-color: #262b2f !important;
  border-color: #262B2F !important;
}

.back_button {
  background-color: #262b2f !important;
  border-color: #262B2F !important;
  margin-bottom: 15px;
  width: 140px;
  cursor: pointer;
}

.price_input {
  width: 80px;
  height: 40px;
}

.orange_background {
  width: 146px !important;
  background: #fb541c !important;
  border-color: #fb541c !important;
}

.page_button {
  display: flex;
  align-items: center;
}

.order_footer {
  width: 96%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  margin:20px 20px 0px 20px;
  .sync-sku{
    width: 30%;
  }
  .tips-txt{
    width: 40%;
    margin-left: 10px;
    text-align: center;
  }
  .btn {
    cursor: pointer;
    padding: 0 10px;
    line-height: 40px;
    height: 40px;
    border: 1px solid #262B2F;
    text-align: center;
    margin-left: 10px;
    font-size: 14px;
    color: #262B2F;
  }
}
.order_main {
  width: 96%;
  margin: 20px 0 0 20px;
}

.order_head_title {
  justify-content: space-between;
  padding-right: 50px;

  .order_num {
    margin-left: 30px;
  }
}

.prduct_box {
  display: flex;
  .product_img {
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    max-width: 100px;
    max-height: 100px;
    object-fit: cover ;
    border: 1px solid #e1e1e1;
  }

  .product_info {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 20px;
    color: #262b2f;
    padding: 12px 0 0 12px;
    position: relative;

  }
  .product_tips{
    font-size: 14px;
    margin-top: 5px;
    color: red;
  }
  .dis_price {
    margin-left: 10px;
  }

  .dis_line {
    text-decoration: line-through;
  }
}

.order_nav {
  width: 96%;
  height: 140px;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  margin-left: 20px;

  .no_border {
    border: none !important;
  }

  .address_width {
    width: auto !important;
    max-width: 40%;

    .nac_msg_num {
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      padding-right: 20px;
      line-height: 18px !important;
    }
  }

  .nav_msg {
    flex-direction: column;
    padding: 20px 0 0 30px;
    width: 12%;
    height: 100%;

    .nac_msg_name {
      color: #5d5d5d;
      border-right: solid 1px #e1e1e1;
    }

    .nac_msg_num {
      padding-top: 10px;
      line-height: 24px;
      color: #262b2f;
      font-size: 14px;
      font-family: Graphik;
      font-weight: 400;
      border-right: solid 1px #e1e1e1;
    }

    .el-dropdown {
      margin-top: 10px;
      width: 80px;
    }

    .el-dropdown-link {
      color: #fff;
    }
  }
}

.gery_color {
  color: #8f8f8f;
  cursor: pointer;
}

.creat_button {
  width: 146px;
  height: 40px;
  background: #262b2f;
  border: 1px solid #262b2f;
  opacity: 1;
  border-radius: 3px;
  outline: none;
  color: #fff;
  font-size: 14px;
}

.add-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 192px;
  height: 38px;
  border-radius: 3px;
  color: #FFFFFF !important;
}

.end_box {
  width: 85%;
  margin-left: 30px;
  padding-bottom: 50px;
  flex-direction: column;
  align-items: flex-end;

  .creat_text {
    width: 45%;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
  }

  .blod_text {
    font-size: 16px;
    font-family: Graphik;
    font-weight: 500;
    color: #262b2f;
  }

  .split {
    border-bottom: 1px solid #E1E1E1;
    width: 100%;
  }
}

.total_amount {
  justify-content: space-between;
  padding-right: 10px;

  .order-delete {
    cursor: pointer;
    font-size: 16px;
  }
}

.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  margin: 0 0 0 10px;
  cursor: pointer;
}

.success_text {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 18px;
  color: #262b2f;
  text-align: center;
  margin-top: 20px;
}

.back_button {
  width: 164px;
  height: 41px;
  border: 1px solid #707070;
  border-radius: 3px;
  margin: 30px 0;
}

.action_button {
  background: #000000;
  color: #ffffff;
  height: 40px;
  line-height: 40px;
  padding: 0 10px !important;

}
.required-error {
  font-size: 12px;
  color: #F77073;
  font-weight: 400;
  height: 20px;
  line-height: 20px;
}

.required-error,.set-restock-date  {
  position: absolute;
  z-index: 99;
  white-space: nowrap;
}

.table-cell-input {
  /deep/ .el-input__inner {
    padding: 0 5px !important;
  }
}

.set-restock-date {
  z-index: 99999;
  border: 1px solid #E1E1E1;
  border-radius: 5px;
  left: -245px;
  top: -5px;
  padding: 5px 10px;
  background: #FFFFFF;

  p:nth-child(1) {
    color: #262B2F;
    font-size: 14px;
    font-weight: 600;
  }
}

.cust-sku-btn {
  font-size: 12px;
  margin-top: 10px;
  text-align: right;
  font-weight: 600;

  span {
    cursor: pointer;
    text-decoration: underline;
  }

  span:nth-child(1) {
    margin-right: 15px;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/edit-item-avaliability.vue